module.exports = __webpack_public_path__ + "img/scene3-1.5bd585dd.png";